// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { subBusinessDays as fn } from "../subBusinessDays.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const subBusinessDaysWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default subBusinessDaysWithOptions;
